import { Token } from 'typedi';

/** This config is used to configure the API bearer token for the app's internal API service. */
export interface ApiBearerTokenConfig {
    bearerTokenProvider: ((url: URL) => string | undefined) | undefined;
}

export const API_BEARER_TOKEN_CONFIG = new Token<ApiBearerTokenConfig>('ApiBearerTokenConfig');
